import cn from 'classnames';

import { EColorMap } from '../constants/colorMap';
import { IConDefaultType } from '../types';


export interface ICameraIconIconProps extends IConDefaultType {}

export default function CameraIcon({
  color = EColorMap.gray_0,
  className,
  size = 24,
  rotate,
  flip,
}: ICameraIconIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.8486 2.08887L10.85 2.08887L13.1514 2.08887C13.8937 2.08988 14.6211 2.29745 15.2522 2.68835C15.8833 3.07924 16.3931 3.63804 16.7247 4.3022L17.1187 5.09028C18.4018 5.12072 19.6259 5.64367 20.5355 6.55333C21.4732 7.49102 22 8.76279 22 10.0889V17.0889C22 18.4149 21.4732 19.6867 20.5355 20.6244C19.5979 21.5621 18.3261 22.0889 17 22.0889H7C5.67392 22.0889 4.40215 21.5621 3.46447 20.6244C2.52678 19.6867 2 18.4149 2 17.0889V10.0889C2 8.76279 2.52678 7.49102 3.46447 6.55333C4.37413 5.64368 5.5982 5.12072 6.88126 5.09028L7.2753 4.3022C7.60688 3.63828 8.1169 3.07913 8.74781 2.68835C9.37889 2.29745 10.1063 2.08988 10.8486 2.08887ZM13.1493 4.08887H10.8507C10.4798 4.08949 10.1163 4.19327 9.80096 4.38861C9.48542 4.58405 9.23049 4.86345 9.0647 5.19553L8.39443 6.53608C8.22504 6.87487 7.87877 7.08887 7.5 7.08887H7C6.20435 7.08887 5.44129 7.40494 4.87868 7.96755C4.31607 8.53016 4 9.29322 4 10.0889V17.0889C4 17.8845 4.31607 18.6476 4.87868 19.2102C5.44129 19.7728 6.20435 20.0889 7 20.0889H17C17.7956 20.0889 18.5587 19.7728 19.1213 19.2102C19.6839 18.6476 20 17.8845 20 17.0889V10.0889C20 9.29322 19.6839 8.53016 19.1213 7.96755C18.5587 7.40494 17.7956 7.08887 17 7.08887H16.5C16.1212 7.08887 15.775 6.87487 15.6056 6.53608L14.9356 5.19608C14.7698 4.864 14.5146 4.58405 14.199 4.38861C13.8837 4.19327 13.5202 4.08949 13.1493 4.08887Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 12.0889C10.8954 12.0889 10 12.9843 10 14.0889C10 15.1934 10.8954 16.0889 12 16.0889C13.1046 16.0889 14 15.1934 14 14.0889C14 12.9843 13.1046 12.0889 12 12.0889ZM8 14.0889C8 11.8797 9.79086 10.0889 12 10.0889C14.2091 10.0889 16 11.8797 16 14.0889C16 16.298 14.2091 18.0889 12 18.0889C9.79086 18.0889 8 16.298 8 14.0889Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 9.58887C15 9.03658 15.4455 8.58887 15.995 8.58887H16.005C16.5545 8.58887 17 9.03658 17 9.58887C17 10.1412 16.5545 10.5889 16.005 10.5889H15.995C15.4455 10.5889 15 10.1412 15 9.58887Z"
          fill={color}
        />
      </svg>
    </i>
  );
}
